import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { store } from './Redux/store'; 
import { Provider } from 'react-redux';
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'

createRoot(document.getElementById('root')).render(


  // basename={'/farm_fusion/app'}

  // basename = "/suregrowth-admin"
  <BrowserRouter

  // basename="/admin" 
  >
    <StrictMode>
        <Provider store={store}>
      <App />
      </Provider>
    </StrictMode>
  </BrowserRouter>
)